import { useQuery } from "convex/react";
import { api } from "../../../convex/_generated/api";

const useGetWhyChooseUs = () => {
  const data = useQuery(api.whyChooseUs.get);
  const isLoading = data === undefined;
  return { data, isLoading };
};

export default useGetWhyChooseUs;
